import React from 'react';
import * as yup from 'yup';
import { Link, withRouter } from 'react-router-dom';
import { useSynapse } from 'app/lib/synaptik';
import { Button, Formbot, Form, Flex, Input, Box, Text } from '@goodrx/matisse';
import { PageHeading } from 'app/components/PageHeading';
import DocumentTitle from 'app/components/core/document-title';
import { AuthLayout } from 'app/components/auth/AuthLayout/AuthLayout';
import { UniversalLink } from 'app/components/links/UniversalLink/UniversalLink';
import { getQueryParams } from 'app/lib/utils';
import qs from 'qs';

function SignInPage({ location, history }: any) {
  const [signIn, signingIn] = useSynapse(({ user }) => [user.signIn, user.state.signingIn]);

  async function handleSignIn({ values, isValid }: { values: { email: string; password: string }; isValid: boolean }) {
    if (!isValid) return;
    try {
      const { next, ...rest } = getQueryParams();
      await signIn(values as any);

      if (next) {
        history.replace({ pathname: next, search: qs.stringify(rest) });
      }
    } catch (error) {}
  }

  return (
    <AuthLayout>
      <DocumentTitle titleKey="SignIn" />
      <PageHeading title="Sign In" subtitle="Sign in to start your online doctor's visit now. No waiting rooms here!" />
      <Formbot
        initialValues={{
          email: (location.state && location.state.email) || '',
          password: '',
        }}
        validationSchema={{
          email: yup.string().required('Please enter your email').email('Invalid email'),
          password: yup.string().required('Please enter your password'),
        }}
        onSubmit={handleSignIn}>
        {({ values }: any) => (
          <Form>
            <Input label="Email Address" floating name="email" placeholder="Email Address" type="email" />
            <Input label="Password" floating name="password" placeholder="Password" type="password" />

            <Flex mt={2} justifyContent="flex-end">
              <Link
                to={{
                  pathname: '/forgot-password',
                  state: location.state,
                }}>
                <Text color="greyDarker" fontSize={14}>
                  Forgot password?
                </Text>
              </Link>
            </Flex>

            <Button mt={4} type="submit" block variant="primary" size="lg" loading={signingIn}>
              Sign In
            </Button>

            <Box mt={4} fontSize={14} textAlign="center">
              <Text color="greyDarker">
                Don&apos;t have an account?{' '}
                <UniversalLink
                  to={{
                    pathname: '/register',
                    state: {
                      ...location.state,
                      email: values.email,
                    },
                  }}>
                  Sign Up
                </UniversalLink>
              </Text>
            </Box>
          </Form>
        )}
      </Formbot>
    </AuthLayout>
  );
}

export default withRouter(SignInPage);
